<template>
  <div class="retrieval">
    <div class="retrieval_nav">
      <div class="jian">
        <div style="width: auto;display: inline-block;padding-bottom: 11px;border-bottom: 3px solid var(--xt);">友情链接</div>
      </div>
      <vue-seamless-scroll :data='userImage' :class-option="optionLeft" step="1" class="seamless-warp2" :style="{ width: kuan + 'px' }" v-if="chao">
        <ul class="retrieval_banner" :style="{ width: kuan2 + 'px' }">
          <li v-for="(item,index) in userImage" :key="index">
            <a :href="item.linkurl" style="text-decoration: none;">
              <img :src="item.titlePhoto" alt="">
              <div class="retrieval_txt">{{item.title}}</div>
             </a>
          </li>
        </ul>
      </vue-seamless-scroll>
      <div class="seamless-warp2" v-if="!chao">
        <ul class="retrieval_banner" :style="{ width: kuan2 + 'px' }">
          <li v-for="(item,index) in userImage" :key="index">
            <a :href="item.linkurl" style="text-decoration: none;">
              <img :src="item.titlePhoto" alt="" :class="item.zt?'add2':''">
              <div class="retrieval_txt" :class="item.zt?'add':''">{{item.title}}</div>
             </a>
          </li>
        </ul>
      </div>
<!--      <div class="link">
        <span style="font-weight: bold;">友情链接：</span>
        <a href="https://www.baidu.com/" style="color: #000000;text-decoration: none;">中华人民共和国国家卫生和计划生育委员会&nbsp;&nbsp;</a> |
        <a href="#" style="color: #000000;text-decoration: none;">&nbsp;&nbsp;中国科学技术协会</a> |
        <a href="#" style="color: #000000;text-decoration: none;">&nbsp;&nbsp;中华人民共和国新闻出版总署</a> |
        <a href="#" style="color: #000000;text-decoration: none;">&nbsp;&nbsp;中华医学会</a> |
        <a href="#" style="color: #000000;text-decoration: none;">&nbsp;&nbsp;中华医学会杂志社</a> |
        <a href="#" style="color: #000000;text-decoration: none;">&nbsp;&nbsp;中国科学技术信息研究所</a> |
        <a href="#" style="color: #000000;text-decoration: none;">&nbsp;&nbsp;中文核心期</a> |
        <a href="#" style="color: #000000;text-decoration: none;">&nbsp;&nbsp;刊要目总览</a> |
        <a href="#" style="color: #000000;text-decoration: none;">&nbsp;&nbsp;中国科学引文数据库（CSCD）</a> |
        <a href="#" style="color: #000000;text-decoration: none;">&nbsp;&nbsp;万方数据</a> |
        <a href="#" style="color: #000000;text-decoration: none;">&nbsp;&nbsp;丁香园</a>
      </div> -->
    </div>
  </div>
</template>

<script>

 export default {
  data () {
    return {
      chao: false,
      kuan: null,
      kuan2: null,
      userImage: [
        {
          id: 1,
          txt: '化学文摘1',
          img: 'http://www.zhxhwk.com/uploads/20133/2013031317467523752385162.jpg',
          zt:false,
          src: ''
        },
      ]
    }
  },
  computed: {
      optionLeft () {
        return {
          limitMoveNum: 2,
          direction: 2,
        }
      }
  },
  methods:{
    //友情链接
    GetHomePageBlockInfo(){
      var that = this;
      that.$httphelper.GetHomePageBlockInfo({
        "journalId": that.$_JournalId,
        "pChannelId": 0,
        "channelId": 2826,
        "jChannelID": 0,
        "dataSourceType": 4,
        "dataShowType": 1,
        "curr": 1,
        "limit": 10,
      }).then(res => {
        if(res.code==200){
          that.userImage = res.data || '';
          console.log(that.userImage.length,'this.userImage.length')
          if(that.userImage.length>4){
            that.kuan = 275*that.userImage.length*2;
            that.kuan2 = 275*that.userImage.length;
            setTimeout(function(){
              that.chao = true;
            },100)
          }else{
            that.chao = false;
          }
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //页面初始化
    index(){
      this.GetHomePageBlockInfo();
    },
  },
  mounted(){
      this.index();
  },
}
</script>

<style lang="scss" scoped>
.retrieval{
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  padding-top: 38px;
  .retrieval_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    .jian{
      width: 100%;
      border-bottom: 1px solid #DBDBDB;
      font-size: 20px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #000000;
      line-height: 23px;
      position: relative;
      .xian{
        width: 91px;
        height: 3px;
        z-index: 1;
        background-color: var(--biao);
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    .seamless-warp2 {
      overflow: hidden;
      height: 250px;
      .retrieval_banner{
        overflow: hidden;
        list-style: none;
        padding: 39px 0 44px 0;
        li{
          width: 255px;
          margin-right: 20px;
          float: left;
          text-align: center;
          background: #FFFFFF;
          img{
            width: 100%;
            height: 58px;
            margin-bottom: 35px;
            display: flex;
            border: 1px solid #EDEDED;
          }
          .retrieval_txt{
            height: 16px;
            font-size: 16px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #151515;
            line-height: 6px;
          }
          .retrieval_txt:hover{
             color: var(--xt)!important;
          }
        }
      }
    }
    .link{
      width: 100%;
      margin: 0 auto;
      overflow: hidden;
      font-size: 16px;
      font-family: Source Han Sans SC;
      line-height: 28px;
      text-decoration: none;
      position: absolute;
      bottom: 60px;
    }
  }
}
.add{

}
.add2{
  box-shadow: 0px 1px 15px 0px rgba(150, 150, 150, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/public/home/retrieval.vue